import {
    FormError,
} from 'app/types/common.types'
import FormErrorLabels from 'app/shared-components/FormErrorLabels'
import useStyles from './FormErrorList.styles'

type Props = {
    value?: FormError[]
    labelPrefix: string
}
const FormErrorList = ({
    value = [],
    labelPrefix,
}: Readonly<Props>) => {
    const {
        classes,
    } = useStyles()

    return (
        <div className={classes.container}>
            {value.map((error, i) => {
                return (
                    <FormErrorLabels
                        // eslint-disable-next-line react/no-array-index-key
                        key={`form-error-${i}`}
                        error={error}
                        id={labelPrefix}
                    />
                )
            })}
        </div>
    )
}

export default FormErrorList
